import { combineReducers } from "redux";
import { default as auth } from "./auth";
import { default as pagination } from "./pagination";
import { default as entities } from "./entities";
import { default as editor } from "./editor";
import { default as emailModuleEditor } from "./emailModuleEditor";
import { default as emailTemplateEditor } from "./emailTemplateEditor";
import { default as qa } from "./qa";
import { default as modal } from "./modal";

export default combineReducers({
  auth,
  pagination,
  editor,
  emailModuleEditor,
  emailTemplateEditor,
  qa,
  modal,
  entities,
});
